module.exports = __webpack_public_path__ + "img/monobank_logo.e0a19ab2.png";